export default function Textarea({ label, error, className = '', id, ...props }) {
  const areaId = id || props.name;

  return (
    <div className={className}>
      {label && (
        <label htmlFor={areaId} className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <textarea
        id={areaId}
        rows={4}
        className={`w-full rounded-md border px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400
          focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary
          ${error ? 'border-red-400' : 'border-gray-300'}`}
        {...props}
      />
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
}
